module.exports = flarum.reg.get('core', 'forum/states/PostStreamState');